import { useState, useEffect } from "react";
import Toggle from "../../components/Toggle/Toggle";
import Typography from "../../components/Typography/Typography";
import ApiManager from "../../api/ApiManager.js";
import { useAuth } from "../../store/AuthContext/AuthContext";

const PreferencesSection = ({ userData }) => {
  const [dataConversion, setDataConversion] = useState(
    userData?.DataConversion !== undefined ? userData.DataConversion : true
  );
  const [emailSend, setEmailSend] = useState(
    userData?.EmailSend !== undefined ? userData.EmailSend : true
  );

  const { getCookie } = useAuth();
  const id_token = getCookie("id_token");
  const api = new ApiManager();

  const handleToggleChange = (key, value) => {
    // Prepara il payload con il solo valore che è cambiato
    const payload = {
      updates: {
        [key]: value,
      },
    };

    // Aggiorna lo stato locale
    if (key === "DataConversion") {
      setDataConversion(value);
    } else if (key === "EmailSend") {
      setEmailSend(value);
    }

    // Invia l'aggiornamento all'API
    api
      .put("/update", payload, {
        headers: { Authorization: `Bearer ${id_token}` },
      })
      .then((response) => {
        // TODO: toast
      })
      .catch((error) => {
        console.error(`Errore nell'aggiornamento di ${key}:`, error);
        // Ripristina lo stato precedente in caso di errore
        if (key === "DataConversion") {
          setDataConversion(!value);
        } else if (key === "EmailSend") {
          setEmailSend(!value);
        }
      });
  };

  return (
    <div className="w-100 flex w-full flex-col items-end gap-9">
      <div className="w-full flex flex-col gap-3">
        <Typography size="20" weight="sb">
          Conservazione dei dati AI
        </Typography>
        <div className="flex gap-9 items-center w-full justify-between">
          <Typography size="16" color="gray-600">
            La conservazione dei dati AI consente ad Athena di utilizzare le tue
            ricerche per migliorare i modelli di intelligenza artificiale.
            Disattiva questa impostazione se desideri escludere i tuoi dati da
            questo processo.
          </Typography>
          <Toggle
            id="conservazione-dati-ai"
            checked={dataConversion}
            onChange={(value) => handleToggleChange("DataConversion", value)}
          />
        </div>
      </div>
      <div className="w-full flex flex-col gap-3">
        <Typography size="20" weight="sb">
          Email
        </Typography>
        <div className="flex gap-9 items-center w-full justify-between">
          <Typography size="16" color="gray-600">
            Non inviamo spam. Ti contatteremo solo se strettamente necessario.
            Alcune email relative alla tua password non possono essere
            disattivate per garantire la tua sicurezza.
          </Typography>
          <Toggle
            id="email"
            checked={emailSend}
            onChange={(value) => handleToggleChange("EmailSend", value)}
          />
        </div>
      </div>
    </div>
  );
};

export default PreferencesSection;
